import React, { useState, useEffect } from "react";
import LeftNav from "../common/LeftNav";
import TopNav from "../common/TopNav";

import "../../assets/styles/FAQAccordion.css"; // ✅ import css
import up from "../../assets/img/up.svg";
import down from "../../assets/img/down.svg";
import leftarrow from "../../assets/img/personal-left.svg";
import { useNavigate } from "react-router-dom";
import userService from "../../../services/userService";
import { toast } from 'react-toastify';

/* NEW: import edit & delete icons you mentioned */
import editadminweb from "../../assets/img/editadminweb.svg";
import deleteadminweb from "../../assets/img/deleteadminweb.svg";

const FAQAccordion = () => {
  const navigate = useNavigate();

  // API Integration States
  const [loading, setLoading] = useState(false);
  const [faqs, setFaqs] = useState([]);
  const [openIndex, setOpenIndex] = useState(0);

  // Modal states
  const [addOpen, setAddOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingId, setEditingId] = useState(null);

  // Form states for Add FAQ
  const [addFaqQuestion, setAddFaqQuestion] = useState('');
  const [addFaqAnswer, setAddFaqAnswer] = useState('');
  const [addFaqLink, setAddFaqLink] = useState('');
  const [addFaqUserType, setAddFaqUserType] = useState('all');

  // Form states for Edit FAQ
  const [editFaqQuestion, setEditFaqQuestion] = useState('');
  const [editFaqAnswer, setEditFaqAnswer] = useState('');
  const [editFaqLink, setEditFaqLink] = useState('');
  const [editFaqUserType, setEditFaqUserType] = useState('all');

  const userTypes = [
    { label: 'All Users', value: 'all' },
    { label: 'Agent', value: 'agent' },
    { label: 'Agency', value: 'agency' },
    { label: 'Builder', value: 'builder' },
  ];

  // Load FAQs on component mount
  useEffect(() => {
    loadFAQs();
  }, []);

  const loadFAQs = async () => {
    try {
      setLoading(true);
      const response = await userService.getFAQs();
      if (response.success && response.data) {
        setFaqs(response.data);
      } else {
        setFaqs([]);
      }
    } catch (error) {
      console.error('Error loading FAQs:', error);
      toast.error('Failed to load FAQs');
    } finally {
      setLoading(false);
    }
  };

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Add FAQ handlers
  const openAddModal = () => {
    setAddFaqQuestion('');
    setAddFaqAnswer('');
    setAddFaqLink('');
    setAddFaqUserType('all');
    setAddOpen(true);
  };

  const closeAddModal = () => {
    setAddOpen(false);
  };

  const handleSaveNewFaq = async () => {
    if (!addFaqQuestion.trim() || !addFaqAnswer.trim()) {
      toast.warning('Question and Answer are required');
      return;
    }

    try {
      setLoading(true);
      const payload = {
        question: addFaqQuestion,
        answer: addFaqAnswer,
        video_url: addFaqLink,
        category: 'general',
        user_type: addFaqUserType
      };

      const response = await userService.createFAQ(payload);
      if (response.success) {
        toast.success('FAQ added successfully');
        setAddOpen(false);
        loadFAQs(); // Reload list
      } else {
        toast.error(response.message || 'Failed to add FAQ');
      }
    } catch (error) {
      console.error('Error adding FAQ:', error);
      toast.error('Failed to add FAQ');
    } finally {
      setLoading(false);
    }
  };

  // Edit FAQ handlers
  const openEditModal = (index) => {
    const faq = faqs[index] || {};
    setEditingId(faq.id);
    setEditingIndex(index);
    setEditFaqQuestion(faq.question || '');
    setEditFaqAnswer(faq.answer || '');
    setEditFaqLink(faq.video_url || '');
    setEditFaqUserType(faq.user_type || 'all');
    setEditOpen(true);
  };

  const closeEditModal = () => {
    setEditOpen(false);
    setEditingIndex(null);
    setEditingId(null);
  };

  const handleUpdateFaq = async () => {
    if (!editingId) return;
    if (!editFaqQuestion.trim() || !editFaqAnswer.trim()) {
      toast.warning('Question and Answer are required');
      return;
    }

    try {
      setLoading(true);
      const payload = {
        question: editFaqQuestion,
        answer: editFaqAnswer,
        video_url: editFaqLink,
        user_type: editFaqUserType
      };

      const response = await userService.updateFAQ(editingId, payload);
      if (response.success) {
        toast.success('FAQ updated successfully');
        setEditOpen(false);
        loadFAQs(); // Reload list
      } else {
        toast.error(response.message || 'Failed to update FAQ');
      }
    } catch (error) {
      console.error('Error updating FAQ:', error);
      toast.error('Failed to update FAQ');
    } finally {
      setLoading(false);
    }
  };

  // Delete FAQ handler
  const handleDeleteFaq = async (index) => {
    const faq = faqs[index];
    if (!faq || !faq.id) return;

    try {
      setLoading(true);
      const response = await userService.deleteFAQ(faq.id);
      if (response.success) {
        toast.success('FAQ deleted successfully');
        loadFAQs();
      } else {
        toast.error(response.message || 'Failed to delete FAQ');
      }
    } catch (error) {
      console.error('Error deleting FAQ:', error);
      toast.error('Failed to delete FAQ');
    } finally {
      setLoading(false);
    }
  };

  // User Type Selector Component
  const renderUserTypeSelector = (selectedType, setSelectedType) => (
    <div className="user-type-container d-flex flex-wrap gap-2 mt-2">
      {userTypes.map((type) => (
        <button
          key={type.value}
          type="button"
          className={`btn btn-sm ${selectedType === type.value ? 'btn-primary' : 'btn-outline-secondary'}`}
          onClick={() => setSelectedType(type.value)}
        >
          {type.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="d-flex" style={{ background: "#fff", minHeight: "100vh" }}>
      {/* Left Sidebar */}
      <LeftNav />

      {/* Main Content Area */}
      <div className="flex-grow-1">
        <TopNav />
        <div className="p-4">
          <div className=" faq-content p-4">
            <div className="helpsupport">
              <img
                src={leftarrow}
                alt="back"
                onClick={() => {
                  navigate(-1);
                }}
                style={{ cursor: "pointer" }}
                className="me-2"
                width={28}
                height={28}
              />
              Help and Support
            </div>
            <h3 className="faqs-helpsupport mt-4 mb-4">FAQs</h3>

            {/* NEW: Floating Add FAQ Button (keeps the design you used elsewhere) */}
            <button
              className="faq-add-btn"
              onClick={openAddModal}
              title="Add FAQ"
              type="button"
            >
              Add FAQ
            </button>

            {loading && faqs.length === 0 ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
              </div>
            ) : faqs.length === 0 ? (
              <div className="text-center py-4">
                <p className="text-muted">No FAQs found.</p>
              </div>
            ) : (
              faqs.map((faq, index) => (
                <div
                  key={faq.id || index}
                  className={`faq-card mb-3 mt-2 bg-white ${openIndex === index ? "active" : ""}`}
                >
                  <div
                    className="w-100 d-flex justify-content-between align-items-center p-3 border-0 bg-transparent"
                    onClick={() => toggleFAQ(index)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center faq-question">
                      <span className="me-2">{faq.question}</span>
                      <span className="badge bg-light text-dark" style={{ fontSize: '10px' }}>
                        {faq.user_type === 'all' ? 'All' : faq.user_type.charAt(0).toUpperCase() + faq.user_type.slice(1)}
                      </span>
                    </div>

                    {/* Action icons grouped - clicking them should NOT toggle the accordion; stopPropagation */}
                    <div className="faq-action-icons" onClick={(e) => e.stopPropagation()}>
                      <button className="faq-icon-btn" title="Edit" onClick={() => openEditModal(index)}>
                        <img src={editadminweb} alt="edit" width={18} height={18} />
                      </button>
                      <button className="faq-icon-btn" title="Delete" onClick={() => handleDeleteFaq(index)}>
                        <img src={deleteadminweb} alt="delete" width={18} height={18} />
                      </button>
                      <button
                        type="button"
                        className="faq-icon-btn"
                        title={openIndex === index ? "Close answer" : "Open answer"}
                        aria-label={openIndex === index ? "Close answer" : "Open answer"}
                        aria-expanded={openIndex === index}
                        onClick={() => setOpenIndex(openIndex === index ? null : index)}
                      >
                        <img
                          src={openIndex === index ? down : up}
                          alt=""
                          style={{ width: "24px", height: "24px", marginLeft: 8 }}
                        />
                      </button>
                    </div>
                  </div>

                  <div className="faq-answer px-3 ">
                    {openIndex === index && (
                      <>
                        <p className="mb-2">{faq.answer}</p>
                        {faq.video_url && (
                          <div className="mt-2 video-container">
                            <iframe
                              src={faq.video_url}
                              title="FAQ Video"
                              frameBorder="0"
                              allowFullScreen
                            ></iframe>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {/* ADD MODAL */}
      {addOpen && (
        <div className="faq-modal-overlay" onClick={() => closeAddModal()}>
          <div className="faq-modal" onClick={(e) => e.stopPropagation()}>
            <div className="faq-modal-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Add New FAQ</h5>
              <button className="btn-close" onClick={() => closeAddModal()} />
            </div>
            <div className="faq-modal-body">
              <div className="mb-3">
                <label className="form-label">Show To (Select One)</label>
                {renderUserTypeSelector(addFaqUserType, setAddFaqUserType)}
              </div>
              <div className="mb-3">
                <label className="form-label">FAQ Question</label>
                <input
                  className="form-control"
                  placeholder="Enter FAQ Question"
                  value={addFaqQuestion}
                  onChange={(e) => setAddFaqQuestion(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">FAQ Answer</label>
                <textarea
                  className="form-control"
                  placeholder="Enter FAQ Answer"
                  value={addFaqAnswer}
                  onChange={(e) => setAddFaqAnswer(e.target.value)}
                  rows="4"
                />
              </div>
              <div className="mb-3">
                <label className="form-label text-primary">Add Link (Optional)</label>
                <input
                  className="form-control"
                  placeholder="Add video link"
                  value={addFaqLink}
                  onChange={(e) => setAddFaqLink(e.target.value)}
                />
              </div>
            </div>
            <div className="faq-modal-actions d-flex justify-content-end gap-2">
              <button className="btn btn-outline-secondary" onClick={() => closeAddModal()}>
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={() => handleSaveNewFaq()}
                disabled={loading}
              >
                {loading ? 'Adding...' : 'Add'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* EDIT MODAL */}
      {editOpen && (
        <div className="faq-modal-overlay" onClick={() => closeEditModal()}>
          <div className="faq-modal" onClick={(e) => e.stopPropagation()}>
            <div className="faq-modal-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Edit FAQ</h5>
              <button className="btn-close" onClick={() => closeEditModal()} />
            </div>
            <div className="faq-modal-body">
              <div className="mb-3">
                <label className="form-label">Show To (Select One)</label>
                {renderUserTypeSelector(editFaqUserType, setEditFaqUserType)}
              </div>
              <div className="mb-3">
                <label className="form-label">FAQ Question</label>
                <input
                  className="form-control"
                  value={editFaqQuestion}
                  onChange={(e) => setEditFaqQuestion(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">FAQ Answer</label>
                <textarea
                  className="form-control"
                  value={editFaqAnswer}
                  onChange={(e) => setEditFaqAnswer(e.target.value)}
                  rows="4"
                />
              </div>
              <div className="mb-3">
                <label className="form-label text-primary">Link</label>
                <input
                  className="form-control"
                  placeholder="Add link"
                  value={editFaqLink}
                  onChange={(e) => setEditFaqLink(e.target.value)}
                />
              </div>
            </div>
            <div className="faq-modal-actions d-flex justify-content-between align-items-center">
              <button
                className="btn btn-outline-danger"
                onClick={() => {
                  handleDeleteFaq(editingIndex);
                  closeEditModal();
                }}
                disabled={loading}
              >
                {loading ? 'Deleting...' : 'Delete'}
              </button>
              <div>
                <button className="btn btn-outline-secondary me-2" onClick={() => closeEditModal()}>
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => handleUpdateFaq()}
                  disabled={loading}
                >
                  {loading ? 'Updating...' : 'Update'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FAQAccordion;
